import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import ModalHeader from '../../../common/headers/ModalHeader';
import { configs } from '../../../../constants/configs/configs';


const GetAssistanceModal = (props) => {

    const {
        modalHeaderProps,
        modal : {
            modalData: {
                CONTACT_US,
                PHONE,
                handleOpeningModal,
                setForAgentPromotion,
                isState
            }
        },
        actions: {
            hideModal
        }
    } = props;

    const handleCloseModal = () => {
        setForAgentPromotion();
        hideModal();
    };
    const img_url = configs.ENV.DEVELOPMENT ? '../../../../../assets/images/agent_promotion.jpg' : '/hix/resources/spa/assets/images/agent_promotion.jpg';

    const replacePhone = (phone) => {
        phone = phone.split(',')[0];
        let splitNumber = phone.split('.');
        return splitNumber.join('-');
    };

    const phoneNum = PHONE.includes('.') ? replacePhone(PHONE) : PHONE;

    return (
        <Fragment>
            <ModalHeader {...modalHeaderProps }/>
            <div id="accessCodeErrorModal" className="grid-container">
                <div className='gi-modal__body get-assistance-modal' data-automation-id='get-assistance-modal'>
                    <div className='grid-col-6 get-assistance-img' data-automation-id='get-assistance-img'>
                        <img src={img_url} alt='TechSupportWoman' data-automation-id='TechSupportWoman'/>
                    </div>
                    <div className='grid-col-6 text-center modal__content'>
                        { isState.PA || isState.VA ?
                            ( <Fragment>
                                <p className='text-left get-assistance-contact-us' data-automation-id='get-assistance-contact-us'>
                                    <FormattedMessage id='modals.get_assistance.call_us_text'/>
                                    <a href={`tel:${phoneNum}`}>
                                        <b><FormattedMessage id='modals.get_assistance.call_us_phone' values={{ phone: phoneNum }}/></b>
                                    </a>
                                    <FormattedMessage id='modals.get_assistance.call_us_or'/>
                                    <a href={CONTACT_US} className='get-assistance-contact-us-site' data-automation-id='get-assistance-contact-us-site'><FormattedMessage id='modals.get_assistance.contact_us.link'/></a>
                                    <FormattedMessage id='modals.get_assistance.contact_us.postlink'/>
                                </p>
                                <p className='text-left'><FormattedMessage id='modals.get_assistance.body_one' values={{ lineBreak: <br/> }}/></p>
                                <ul>
                                    <li className='text-left'><FormattedMessage id='modals.get_assistance.body_two'/></li>
                                    <li className='text-left'><FormattedMessage id='modals.get_assistance.body_three'/></li>
                                </ul>
                            </Fragment>) : (
                                <Fragment>
                                    <p className='text-left'>
                                        <FormattedMessage id='modals.get_assistance.why_important'/>
                                    </p>
                                    <ul>
                                        <li className='text-left'><FormattedMessage id='modals.get_assistance.body_two'/></li>
                                        <li className='text-left'><FormattedMessage id='modals.get_assistance.body_three'/></li>
                                    </ul>
                                    <p className='text-left'>
                                        <FormattedMessage id='modals.get_assistance.find_best_and_suit_you' />
                                    </p>
                                </Fragment>
                            ) }
                        <button type='button' className='usa-button gi-button gi-button__primary wide-button' data-automation-id='wide-button' onClick={handleOpeningModal}><FormattedMessage id='button.get_assistance.link'/></button>
                        <a className='get-assistance-dont-ask' data-automation-id='get-assistance-dont-ask' onClick={ () => handleCloseModal()}><FormattedMessage id='modals.get_assistance.dont_ask_again'/></a>
                    </div>
                </div>
            </div>

        </Fragment>
    );
};



export default GetAssistanceModal;